var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useState } from "react";
//Language Translation
import { useTranslation } from "react-i18next";
//Redux Functinality
import { useDispatch, useSelector } from "react-redux";
import { createOrders, dataAddingOnCart } from "../../reduxStore/actions/salesRepDataAction";
//user credentials
import { getLoggedInRepDetails, getLoggedInRepDetailsFromSession, getShippingRatesService } from "../../services/apiServices/salesRepDataService";
//import Component
import { CustomerDetailsBL } from "./CustomerDetailsBL";
import { SalesRepDataActionType } from "../../reduxStore/actions/actionTypes";
import store from "../../reduxStore/store";
import { HandleEditDraftOrder } from "./EditDraftOrder";
import { CREATE_CHECKOUT, CREATE_ORDER_TYPE, DRAFT_ORDER, EDIT_ORDER_FLAG, SHOP_CHECKOUT_SKIP_SHOP_PAY_DOMAIN, TOASTER_TIMEOUT } from "../Constant";
import { isLoading } from "../../services/behaviorSubjectService";
import { SharedFunctions } from "../SharedFunctions";
import { useDeviceQueries } from "../../shared/Utilites";
export function ProductTableBL(props) {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
    var setOrderCreateBtn = CustomerDetailsBL().setOrderCreateBtn;
    var t = useTranslation().t; //* Translation *
    var isMobile = useDeviceQueries(); // mobile view
    var updateStateForEditOrder = HandleEditDraftOrder().updateStateForEditOrder;
    var useInfiniteScroll = SharedFunctions().useInfiniteScroll;
    var dispatch = useDispatch();
    var salesRepData = useSelector(function (state) { return (state.salesRepData ? state.salesRepData : {}); }); // ** Get Data **
    var checkResponsePopUpValue = (_c = (_b = (_a = salesRepData.baseData) === null || _a === void 0 ? void 0 : _a.ConfirmationPopUpStatus) === null || _b === void 0 ? void 0 : _b.isCheckOutPopUpVisible) !== null && _c !== void 0 ? _c : false;
    //Currency Symbol
    var _6 = getLoggedInRepDetails(), shopCurrency = _6.shopCurrency, shopName = _6.shopName, currency = _6.currency; //user credentials
    var _7 = useState((salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.productsData) ? salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.productsData : []), Products = _7[0], setProduct = _7[1];
    var _8 = useState(""), search_By_productInfo = _8[0], setSearch_By_productInfo = _8[1];
    var _9 = useState(""), orderNotes = _9[0], setOrderNotes = _9[1];
    var _10 = useState({ msg: "", color: "blue" }), orderPlacedMsg = _10[0], setOrderPlacedMsg = _10[1];
    var _11 = useState({}), subtotal = _11[0], setSubtotal = _11[1];
    var _12 = useState(0), totalPrice = _12[0], setTotalPrice = _12[1];
    var _13 = useState(false), backToShopBtn = _13[0], setBackToShopBtn = _13[1];
    var _14 = useState({}), product_idObject = _14[0], setProduct_idObject = _14[1];
    var _15 = useState({}), variant_idObject = _15[0], setVariant_idObject = _15[1];
    var _16 = useState([]), productSelectedArray = _16[0], setProductSelectedArray = _16[1];
    var _17 = useState(), scrollParentRef = _17[0], setScrollParentRef = _17[1];
    var _18 = useState(false), searchProductArray = _18[0], setSearchProductArray = _18[1];
    var _19 = useState([]), filterProductScroll = _19[0], setFilterProductScroll = _19[1];
    var customizedStrings = store.getState().salesRepData.baseData.CustomizedBackofficeStrings;
    var _20 = useState({ customerInvoice_contentHeading2Title3: "", customerInvoice_SendInvoiceBtn: "" }), customizedTextStrings = _20[0], setCustomizedTextStrings = _20[1];
    var _21 = useState(store.getState().salesRepData.baseData.hideRetailPriceColumn ? store.getState().salesRepData.baseData.hideRetailPriceColumn : false), hideRetailPriceColumn = _21[0], setHideRetailPriceColumn = _21[1];
    var _22 = useState(""), shippingCost = _22[0], setShippingCost = _22[1];
    var _23 = useState({ msg: "", open: false, severity: "error" }), alertErrorMsg = _23[0], setAlertErrorMsg = _23[1];
    var _24 = useState([]), shippingCostData = _24[0], setShippingCostData = _24[1];
    var shippingAddressFlag = false;
    var _25 = useState(""), shippingAddresSet = _25[0], setShippingAddressSet = _25[1];
    var shippingAddresSetVariable = shippingAddresSet;
    var _26 = useState(""), applyShippingCost = _26[0], setApplyShippingCost = _26[1];
    var _27 = useState(false), isDisabledShippingCostRadioBtn_No = _27[0], setIsDisabledShippingCostRadioBtn_No = _27[1];
    var _28 = useState(false), isDisabledShippingCostRadioBtn_YesNo = _28[0], setIsDisabledShippingCostRadioBtn_YesNo = _28[1];
    var _29 = useState({}), isError = _29[0], setIsError = _29[1];
    var _30 = useState(false), orderCreatedSuccessfully = _30[0], setOrderCreatedSuccessfully = _30[1];
    var _31 = useState(10), productTableRowsPerPage = _31[0], setProductTableRowsPerPage = _31[1];
    var _32 = useState(0), useEffectCount = _32[0], setUseEffectCount = _32[1];
    var _33 = useState(((_d = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.productsData) === null || _d === void 0 ? void 0 : _d.length) > 0 ? false : true), productsLoading = _33[0], setProductsLoading = _33[1];
    var selectFeatures = ((_e = salesRepData.baseData) === null || _e === void 0 ? void 0 : _e.select) ? (_f = salesRepData.baseData) === null || _f === void 0 ? void 0 : _f.select : {};
    //editOrder
    var _34 = useState((_g = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.editDraftOrder) !== null && _g !== void 0 ? _g : {}), editOrderReduxData = _34[0], setEditOrderReduxData = _34[1];
    var _35 = useState(false), wholesalePriceFlag = _35[0], setWholesalePriceFlag = _35[1];
    var _36 = useState(true), sendInvoiceFeature = _36[0], setSendInvoiceFeature = _36[1];
    var _37 = useState(""), selectedOrderType = _37[0], setSelectedOrderType = _37[1];
    var _38 = useState((_k = (_j = (_h = salesRepData.baseData) === null || _h === void 0 ? void 0 : _h.ConfirmationPopUpStatus) === null || _j === void 0 ? void 0 : _j.isCheckOutPopUpVisible) !== null && _k !== void 0 ? _k : false), defaultPopupStateFromDb = _38[0], setDefaultPopupStateFromDb = _38[1];
    var isPopUpChecked = ((_l = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.checkoutConfirmationPopUp) === null || _l === void 0 ? void 0 : _l.IscheckBoxChecked) ? (_m = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.checkoutConfirmationPopUp) === null || _m === void 0 ? void 0 : _m.IscheckBoxChecked : false;
    var _39 = useState(false), cartUpdatedSuccessFully = _39[0], setCartUpdatedSuccessFully = _39[1];
    var _40 = useState(false), isConfirmOpen = _40[0], setIsConfirmOpen = _40[1];
    var isEditOrder = ((_o = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.editDraftOrder) === null || _o === void 0 ? void 0 : _o.actionEvent) === EDIT_ORDER_FLAG;
    var createOrderInnerScroll = useInfiniteScroll(productTableRowsPerPage, setProductTableRowsPerPage, Products);
    //Apply Discount
    var _41 = useState({}), isDiscountError = _41[0], setIsDiscountError = _41[1];
    var _42 = useState({}), discount_idObject = _42[0], setDiscount_idObject = _42[1];
    var _43 = useState("percentage"), selectedDiscountType = _43[0], setSelectedDiscountType = _43[1];
    var _44 = useState(""), discount_ApplyOnSubTotal = _44[0], setDiscount_ApplyOnSubTotal = _44[1];
    var _45 = useState(false), discountAlertBox = _45[0], setDiscountAlertBox = _45[1];
    var _46 = useState("percentage"), pendingDiscountType = _46[0], setPendingDiscountType = _46[1];
    var ShopApplyDiscount = ((_p = selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.featuresAdditionalSettings) === null || _p === void 0 ? void 0 : _p.showApplyDiscount) ? (_q = selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.featuresAdditionalSettings) === null || _q === void 0 ? void 0 : _q.showApplyDiscount : false;
    var isDiscoutAppiedInSubTotal = ((_s = (_r = editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.draftOrderObj) === null || _r === void 0 ? void 0 : _r.applied_discount) === null || _s === void 0 ? void 0 : _s.value) ? (_u = (_t = editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.draftOrderObj) === null || _t === void 0 ? void 0 : _t.applied_discount) === null || _u === void 0 ? void 0 : _u.value : false;
    var isDiscoutAppliedInEditDraft = (discount_idObject && ((_v = Object.keys(discount_idObject)) === null || _v === void 0 ? void 0 : _v.length) > 0) || isDiscoutAppiedInSubTotal;
    useEffect(function () {
        var _a;
        if ((Products === null || Products === void 0 ? void 0 : Products.length) === 0 && ((_a = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.productsData) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            setProduct(salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.productsData);
            if (ShopApplyDiscount || isDiscoutAppliedInEditDraft) {
                setIsDiscountError({});
                setDiscount_idObject({});
            }
        }
        setUseEffectCount(function (prev) {
            if (prev === 1) {
                isLoading.next(false);
                setProductsLoading(false);
            }
            return prev + 1;
        });
    }, [salesRepData.productsData]);
    var inputFieldsData = {
        newAddress: [
            {
                0: (_w = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _w === void 0 ? void 0 : _w.firstName,
                errorMsg: t("customerInvoice_FirstNameErrorMsg"),
            },
            {
                1: (_x = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _x === void 0 ? void 0 : _x.lastName,
                errorMsg: t("customerInvoice_lastNameErrorMsg"),
            },
            {
                2: (_y = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _y === void 0 ? void 0 : _y.address1,
                errorMsg: t("customerInvoice_Add1ErrorMsg"),
            },
            {
                3: (_z = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _z === void 0 ? void 0 : _z.selectCountry,
                errorMsg: t("customerInvoice_CountryErrorMsg"),
            },
            {
                4: (_0 = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _0 === void 0 ? void 0 : _0.selectCountryState,
                errorMsg: t("customerInvoice_StateErrorMsg"),
            },
            {
                5: (_1 = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _1 === void 0 ? void 0 : _1.city,
                errorMsg: t("customerInvoice_CityErrorMsg"),
            },
            {
                6: (_2 = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _2 === void 0 ? void 0 : _2.zipNumber,
                errorMsg: t("customerInvoice_ZipErrorMsg"),
            },
        ],
    };
    useEffect(function () {
        var _a;
        if ((_a = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.baseData) === null || _a === void 0 ? void 0 : _a.completedGetProductApi) {
            setProductsLoading(false);
        }
        else {
            setProductsLoading(true);
        }
        setCustomizedTextStrings(customizedStrings[shopName] ? JSON.parse(customizedStrings[shopName]) : customizedTextStrings);
        //for edit order
        if (isEditOrder) {
            // update discount values
            ReduxDiscountedValues();
            updateStateForEditOrder("autoFatchDataForEditOrder", {
                props: props,
                setProductSelectedArray: setProductSelectedArray,
                setProduct_idObject: setProduct_idObject,
                setVariant_idObject: setVariant_idObject,
                setSubtotal: setSubtotal,
                setOrderNotes: setOrderNotes,
                setAlertErrorMsg: setAlertErrorMsg,
                setApplyShippingCost: setApplyShippingCost,
                setShippingCost: setShippingCost,
                GetShippingRatesOnSelectedAddress: GetShippingRatesOnSelectedAddress,
                handleUpdateReduxState: handleUpdateReduxState,
            });
        }
    }, []);
    useEffect(function () {
        if ((productSelectedArray === null || productSelectedArray === void 0 ? void 0 : productSelectedArray.length) > 0) {
            setProduct_idObject({});
            setVariant_idObject({});
            setSubtotal({});
            setProductSelectedArray([]);
            setIsError({});
        }
    }, [(_3 = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _3 === void 0 ? void 0 : _3.customerName, props === null || props === void 0 ? void 0 : props.tagWiseWholeSalePrices]);
    useEffect(function () {
        //Empty shipping "Cost" & "Options"
        setShippingCost("");
        setShippingCostData([]);
        setApplyShippingCost("");
        setIsDisabledShippingCostRadioBtn_YesNo(false);
    }, [(_4 = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _4 === void 0 ? void 0 : _4.shippingAddress, (_5 = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _5 === void 0 ? void 0 : _5.zipNumber]);
    useEffect(function () {
        if (checkResponsePopUpValue && !isPopUpChecked) {
            setDefaultPopupStateFromDb(true);
        }
        else {
            setDefaultPopupStateFromDb(isPopUpChecked);
        }
    }, [isPopUpChecked, checkResponsePopUpValue]);
    //filterProduct
    var SearchProduct = function (value) {
        var _a, _b, _c, _d;
        setProductTableRowsPerPage(10);
        if (((_a = salesRepData.productsData) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var searchInputKeys_1 = (_b = value.trim().toLocaleLowerCase()) === null || _b === void 0 ? void 0 : _b.split(" ");
            var hasSearchProductText_1 = false;
            var hasSearchVariantText_1 = false;
            var filteredProductRows = [];
            var filterVariantRows = [];
            var existingFilteredProductIds_1 = [];
            filteredProductRows = (_c = salesRepData.productsData) === null || _c === void 0 ? void 0 : _c.filter(function (product) {
                var _a;
                for (var i = 0; i < (searchInputKeys_1 === null || searchInputKeys_1 === void 0 ? void 0 : searchInputKeys_1.length); i++) {
                    if ((product === null || product === void 0 ? void 0 : product.productTitle) && ((_a = product.productTitle.toLowerCase()) === null || _a === void 0 ? void 0 : _a.includes(searchInputKeys_1[i].trim()))) {
                        hasSearchProductText_1 = true;
                    }
                    else {
                        hasSearchProductText_1 = false;
                        break;
                    }
                }
                if (hasSearchProductText_1) {
                    existingFilteredProductIds_1.push(product.productId);
                }
                return hasSearchProductText_1 ? true : false;
            });
            filterVariantRows = (_d = salesRepData.productsData) === null || _d === void 0 ? void 0 : _d.filter(function (product) {
                var _a, _b, _c;
                if (existingFilteredProductIds_1.indexOf(product.productId) > -1) {
                    return false;
                }
                for (var i = 0; i < (searchInputKeys_1 === null || searchInputKeys_1 === void 0 ? void 0 : searchInputKeys_1.length); i++) {
                    for (var j = 0; j < ((_a = product === null || product === void 0 ? void 0 : product.variants) === null || _a === void 0 ? void 0 : _a.length); j++) {
                        if (((product === null || product === void 0 ? void 0 : product.variants[j].variantTitle) && ((_b = product === null || product === void 0 ? void 0 : product.variants[j].variantTitle.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(searchInputKeys_1[i].trim()))) ||
                            ((product === null || product === void 0 ? void 0 : product.variants[j].sku) && ((_c = product === null || product === void 0 ? void 0 : product.variants[j].sku.toLowerCase()) === null || _c === void 0 ? void 0 : _c.includes(searchInputKeys_1[i].trim())))) {
                            hasSearchVariantText_1 = true;
                        }
                    }
                }
                return hasSearchVariantText_1 ? true : false;
            });
            if (hasSearchProductText_1 && hasSearchVariantText_1) {
                filterVariantRows = [];
            }
            var searchArray = __spreadArray(__spreadArray([], filteredProductRows, true), filterVariantRows, true);
            setProduct(searchArray);
        }
    };
    // Set Redux discount value: store and show value as-is from Shopify (fixed amount or percentage), no conversion.
    var ReduxDiscountedValues = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var draftOrder = editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.draftOrderObj;
        var productDetailsArray = (_d = (_c = (_b = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.editDraftOrder) === null || _b === void 0 ? void 0 : _b.productDetailsArray) !== null && _c !== void 0 ? _c : editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.productDetailsArray) !== null && _d !== void 0 ? _d : [];
        var lineItemDiscounts = {};
        var appliedDiscountOnSubTotal;
        if (draftOrder) {
            var lineItems = draftOrder === null || draftOrder === void 0 ? void 0 : draftOrder.line_items;
            var orderAmount = ((_e = draftOrder === null || draftOrder === void 0 ? void 0 : draftOrder.applied_discount) === null || _e === void 0 ? void 0 : _e.amount) != null && ((_f = draftOrder === null || draftOrder === void 0 ? void 0 : draftOrder.applied_discount) === null || _f === void 0 ? void 0 : _f.amount) !== ""
                ? parseFloat(String(draftOrder.applied_discount.amount))
                : NaN;
            if (!Number.isNaN(orderAmount) && orderAmount > 0) {
                appliedDiscountOnSubTotal = orderAmount;
                setSelectedDiscountType("dollar");
            }
            else if (((_g = draftOrder === null || draftOrder === void 0 ? void 0 : draftOrder.applied_discount) === null || _g === void 0 ? void 0 : _g.value) != null && ((_h = Object.keys(draftOrder === null || draftOrder === void 0 ? void 0 : draftOrder.applied_discount)) === null || _h === void 0 ? void 0 : _h.length) > 0) {
                appliedDiscountOnSubTotal = Number((_j = draftOrder === null || draftOrder === void 0 ? void 0 : draftOrder.applied_discount) === null || _j === void 0 ? void 0 : _j.value) || 0;
            }
            var discountType = (_k = draftOrder === null || draftOrder === void 0 ? void 0 : draftOrder.applied_discount) === null || _k === void 0 ? void 0 : _k.value_type;
            if (discountType != "percentage") {
                setSelectedDiscountType("dollar");
            }
            if (lineItems && Array.isArray(lineItems)) {
                lineItems === null || lineItems === void 0 ? void 0 : lineItems.forEach(function (variant) {
                    var _a, _b, _c, _d;
                    var variantId = variant === null || variant === void 0 ? void 0 : variant.variant_id;
                    var amount = ((_a = variant === null || variant === void 0 ? void 0 : variant.applied_discount) === null || _a === void 0 ? void 0 : _a.amount) != null && ((_b = variant === null || variant === void 0 ? void 0 : variant.applied_discount) === null || _b === void 0 ? void 0 : _b.amount) !== ""
                        ? parseFloat(String(variant.applied_discount.amount))
                        : null;
                    if (variantId != null) {
                        if (amount != null && !Number.isNaN(amount) && amount > 0) {
                            lineItemDiscounts[String(variantId)] = amount;
                            setSelectedDiscountType("dollar");
                        }
                        else if (((_c = variant === null || variant === void 0 ? void 0 : variant.applied_discount) === null || _c === void 0 ? void 0 : _c.value) != null && ((_d = variant === null || variant === void 0 ? void 0 : variant.applied_discount) === null || _d === void 0 ? void 0 : _d.value) !== undefined) {
                            lineItemDiscounts[String(variantId)] = variant.applied_discount.value;
                        }
                    }
                });
            }
        }
        if ((productDetailsArray === null || productDetailsArray === void 0 ? void 0 : productDetailsArray.length) > 0) {
            productDetailsArray.forEach(function (item) {
                var _a, _b;
                var variantId = (_a = item === null || item === void 0 ? void 0 : item.variantId) !== null && _a !== void 0 ? _a : item === null || item === void 0 ? void 0 : item.variant_id;
                if (variantId == null)
                    return;
                var appliedDiscount = (_b = item === null || item === void 0 ? void 0 : item.appliedDiscount) !== null && _b !== void 0 ? _b : item === null || item === void 0 ? void 0 : item.applied_discount;
                var amount = (appliedDiscount === null || appliedDiscount === void 0 ? void 0 : appliedDiscount.amount) != null && (appliedDiscount === null || appliedDiscount === void 0 ? void 0 : appliedDiscount.amount) !== ""
                    ? parseFloat(String(appliedDiscount.amount))
                    : NaN;
                if (!Number.isNaN(amount) && amount > 0) {
                    lineItemDiscounts[String(variantId)] = amount;
                    setSelectedDiscountType("dollar");
                }
            });
        }
        if (draftOrder || Object.keys(lineItemDiscounts).length > 0) {
            var discountObject = __assign({}, lineItemDiscounts);
            if (appliedDiscountOnSubTotal !== undefined && appliedDiscountOnSubTotal !== null) {
                discountObject.discountOnSubTotal = appliedDiscountOnSubTotal;
            }
            setDiscount_idObject(discountObject);
        }
    };
    // onClick on {+,-} Button
    var handleQuantityIncrementDecrement = function (variantId, actionType, price) {
        var _a, _b;
        if (variantId && actionType) {
            var subtotalCount = __assign({}, subtotal);
            var VariantIdObject = __assign({}, variant_idObject);
            if (actionType === "add") {
                VariantIdObject[variantId] = variant_idObject[variantId] === "" || variant_idObject[variantId] === undefined ? 1 : parseInt(variant_idObject[variantId]) + 1;
            }
            else {
                //"subtract"
                VariantIdObject[variantId] = variant_idObject[variantId] === "" || variant_idObject[variantId] === undefined ? 1 : Math.max(variant_idObject[variantId] - 1, 1);
            }
            subtotalCount[variantId] = VariantIdObject[variantId] * price;
            var variantAndQuantityObject = (_a = {},
                _a[variantId] = VariantIdObject[variantId],
                _a);
            if (ShopApplyDiscount || isDiscoutAppliedInEditDraft) {
                var DiscountIdObject = __assign({}, discount_idObject);
                var isDicountOnvariantId = DiscountIdObject.hasOwnProperty(variantId);
                if (isDicountOnvariantId) {
                    var discountApplied = 0.0;
                    if (selectedDiscountType === "percentage") {
                        discountApplied = subtotalCount[variantId] - (parseFloat(DiscountIdObject[variantId]) * subtotalCount[variantId]) / 100;
                    }
                    else {
                        var discountedAmountOfSingleProduct = price - parseFloat(DiscountIdObject[variantId]);
                        discountApplied = VariantIdObject[variantId] * discountedAmountOfSingleProduct;
                    }
                    subtotalCount[variantId] = discountApplied;
                }
            }
            productAddOnCart(variantAndQuantityObject, "update.js"); //Product Updating on Cart Json
            setVariant_idObject(__assign({}, VariantIdObject));
            setSubtotal(__assign({}, subtotalCount));
            setIsError(__assign(__assign({}, isError), (_b = {}, _b[variantId] = false, _b)));
        }
        else {
            setAlertErrorMsg({ msg: t("customerInvoice_AlertErrorMsg"), open: true });
        }
    };
    var handleSelectedBtn = function () {
        setBackToShopBtn(true);
        setSearchProductArray(false);
        setProduct(productSelectedArray);
        setProductTableRowsPerPage(10);
    };
    var handleBackToShopBtn = function () {
        setBackToShopBtn(false);
        setProduct((salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.productsData) ? salesRepData.productsData : []);
        setProductTableRowsPerPage(10);
        return search_By_productInfo !== "" ? setSearch_By_productInfo("") : null;
    };
    // images set
    var renderImageSrc = function (image_id, productImages) {
        var src = productImages[0].src;
        if (image_id && (productImages === null || productImages === void 0 ? void 0 : productImages.length) !== 0) {
            productImages === null || productImages === void 0 ? void 0 : productImages.map(function (img) {
                if (img.imageId === image_id) {
                    return (src = img.src ? img.src : "image");
                }
            });
        }
        return src;
    };
    var successMessages = {
        createOrder: t("customerInvoice_OrderCreatedSuccessfullyMsg"),
        draftOrder: t("customerInvoice_DraftOrderCreatedSuccessfullyMsg"),
        CreateCheckout: t("customerInvoice_DraftOrderCreatedSuccessfullyMsg") + ", " + t("RepCheckout_RedirectionMsg"),
    };
    var loadingMessages = {
        draftOrder: t("customerInvoice_CreatingDraft_Msg"),
        CreateCheckout: t("customerInvoice_CreatingDraft_Msg"),
        createOrder: t("customerInvoice_Creating_Msg"),
    };
    var handleOrderTypeChange = function (value) {
        setSelectedOrderType(value);
        if (value === CREATE_ORDER_TYPE) {
            setSendInvoiceFeature(true);
        }
    };
    var handleOtherFieldsValidation = function () {
        var _a, _b;
        var isValid = true;
        //show error msg "Would you like to add Shipping cost?
        if (shippingAddressFlag && shippingAddresSetVariable !== "" && applyShippingCost === "" && ((_a = selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.featuresAdditionalSettings) === null || _a === void 0 ? void 0 : _a.showShippingCalculation)) {
            setAlertErrorMsg({ msg: t("customerInvoice_ShippingCostAddOrNot_Msg"), open: true });
            isValid = false;
        }
        var quantityErrorValidation = (_b = Object === null || Object === void 0 ? void 0 : Object.values(isError)) === null || _b === void 0 ? void 0 : _b.every(function (value) { return !value; }); //check quantity text-box
        if (!quantityErrorValidation) {
            isValid = false;
            setAlertErrorMsg({ msg: t("productTable_error_AlertMsg"), open: true });
        }
        if (ShopApplyDiscount || isDiscoutAppliedInEditDraft) {
            var CheckDiscountValidation = Object.values(isDiscountError).every(function (value) { return !value; }); //check discount text-box
            if (!CheckDiscountValidation) {
                isValid = false;
                setAlertErrorMsg({ msg: t("discountRangeErrorMsg"), open: true });
            }
        }
        return isValid;
    };
    // Send Invoice & Order Create
    var CreateOrder = function (orderType) { return __awaiter(_this, void 0, void 0, function () {
        var _a, CustomerId, email, customerEmail, customerId, selectedAddressObject_1, shippingaddressID_1, isValid, isDraftOrderValid, isShippingValid, createOrderDataObject, SelectedProductObject, customer_Address, shipping_Name, shipping_Cost, selectShippingCost, cost, title, successDataPost, error_1;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3;
        return __generator(this, function (_4) {
            switch (_4.label) {
                case 0:
                    _4.trys.push([0, 3, , 4]);
                    _a = getLoggedInRepDetailsFromSession(), CustomerId = _a.CustomerId, email = _a.email;
                    customerEmail = email;
                    customerId = CustomerId;
                    selectedAddressObject_1 = {};
                    checkConditions(CREATE_ORDER_TYPE, orderType); //checking shipping address
                    shippingaddressID_1 = ((_b = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _b === void 0 ? void 0 : _b.shippingAddress)
                        ? (_c = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _c === void 0 ? void 0 : _c.shippingAddress.toString()
                        : (_f = (_e = (_d = store.getState().salesRepData) === null || _d === void 0 ? void 0 : _d.createOrderTab) === null || _e === void 0 ? void 0 : _e.customer_shippingaddressID) !== null && _f !== void 0 ? _f : "";
                    isValid = handleOtherFieldsValidation();
                    isDraftOrderValid = orderType === DRAFT_ORDER && isValid;
                    isShippingValid = shippingAddressFlag &&
                        shippingAddresSetVariable !== "" &&
                        (!((_g = selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.featuresAdditionalSettings) === null || _g === void 0 ? void 0 : _g.showShippingCalculation) || applyShippingCost === "No" || shippingCost !== "") &&
                        isValid;
                    if (!(isDraftOrderValid || isShippingValid)) return [3 /*break*/, 2];
                    createOrderDataObject = {};
                    SelectedProductObject = [];
                    customer_Address = [];
                    shipping_Name = null;
                    shipping_Cost = null;
                    selectShippingCost = shippingCost === null || shippingCost === void 0 ? void 0 : shippingCost.split("/");
                    cost = selectShippingCost === null || selectShippingCost === void 0 ? void 0 : selectShippingCost.pop();
                    title = selectShippingCost === null || selectShippingCost === void 0 ? void 0 : selectShippingCost.join("/");
                    if (title !== "" && cost !== "") {
                        shipping_Name = title;
                        shipping_Cost = cost;
                    }
                    //    selected Products as a Object wise store in Array
                    productSelectedArray === null || productSelectedArray === void 0 ? void 0 : productSelectedArray.map(function (product) {
                        var _a;
                        (_a = product === null || product === void 0 ? void 0 : product.variants) === null || _a === void 0 ? void 0 : _a.map(function (variant) {
                            var _a;
                            variant["quantity"] = variant_idObject[variant.variantId];
                            variant["product_type"] = (_a = product === null || product === void 0 ? void 0 : product.product_type) !== null && _a !== void 0 ? _a : "";
                            SelectedProductObject = __spreadArray(__spreadArray([], SelectedProductObject, true), [variant], false);
                        });
                    });
                    if (shippingAddresSetVariable === "customerAddress") {
                        (_h = props === null || props === void 0 ? void 0 : props.customerAddressesList) === null || _h === void 0 ? void 0 : _h.map(function (option) {
                            if (option.id.toString() === shippingaddressID_1.toString()) {
                                selectedAddressObject_1 = option;
                                customer_Address = [
                                    {
                                        fname: (option === null || option === void 0 ? void 0 : option.first_name) || "",
                                        lastname: (option === null || option === void 0 ? void 0 : option.last_name) || "",
                                        address1: (option === null || option === void 0 ? void 0 : option.address1) || "",
                                        address2: (option === null || option === void 0 ? void 0 : option.address2) || "",
                                        city: (option === null || option === void 0 ? void 0 : option.city) || "",
                                        country: (option === null || option === void 0 ? void 0 : option.country) || "",
                                        province: (option === null || option === void 0 ? void 0 : option.province) || "",
                                        zip: (option === null || option === void 0 ? void 0 : option.zip) || "",
                                    },
                                ];
                            }
                        });
                    }
                    else if (shippingAddresSetVariable === "formAddress") {
                        customer_Address = [
                            {
                                fname: (_j = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _j === void 0 ? void 0 : _j.firstName,
                                lastname: (_k = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _k === void 0 ? void 0 : _k.lastName,
                                address1: (_l = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _l === void 0 ? void 0 : _l.address1,
                                address2: (_m = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _m === void 0 ? void 0 : _m.address2,
                                province: (_o = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _o === void 0 ? void 0 : _o.selectCountryState,
                                city: (_p = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _p === void 0 ? void 0 : _p.city,
                                country: (_q = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _q === void 0 ? void 0 : _q.selectCountryCode,
                                zip: (_r = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _r === void 0 ? void 0 : _r.zipNumber,
                            },
                        ];
                    }
                    if (shippingAddresSetVariable === "formAddress" || shippingAddresSetVariable === "customerAddress") {
                        customer_Address[0]["company"] = ((_s = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _s === void 0 ? void 0 : _s.companyName) ? (_t = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _t === void 0 ? void 0 : _t.companyName : (_u = selectedAddressObject_1 === null || selectedAddressObject_1 === void 0 ? void 0 : selectedAddressObject_1.company) !== null && _u !== void 0 ? _u : "";
                        customer_Address[0]["phone"] = ((_v = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _v === void 0 ? void 0 : _v.mobileNumber) ? (_w = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _w === void 0 ? void 0 : _w.mobileNumber : (_x = selectedAddressObject_1 === null || selectedAddressObject_1 === void 0 ? void 0 : selectedAddressObject_1.phone) !== null && _x !== void 0 ? _x : "";
                    }
                    //Data Post...
                    createOrderDataObject = __assign(__assign(__assign({}, (!isEditOrder && { email: customerEmail })), (isEditOrder && {
                        repEmail: customerEmail,
                        orderId: (_y = editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.draftOrderObj) === null || _y === void 0 ? void 0 : _y.id,
                        orderTags: (_z = editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.draftOrderObj) === null || _z === void 0 ? void 0 : _z.tags,
                        additionalNoteDetails: (_1 = (_0 = editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.draftOrderObj) === null || _0 === void 0 ? void 0 : _0.note_attributesList) !== null && _1 !== void 0 ? _1 : [],
                    })), {
                        prods: JSON.stringify(SelectedProductObject),
                        customerId: customerId,
                        Index: -1,
                        fnamecus: (_2 = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _2 === void 0 ? void 0 : _2.customerName,
                        cusemail: (_3 = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _3 === void 0 ? void 0 : _3.emailId,
                        wholesale: "false",
                        message: orderNotes,
                        cusAddress: customer_Address,
                        shippingtitle: shipping_Name,
                        shippingprice: shipping_Cost,
                        IsAdressFromCustmerInvoice: false,
                        completeDraftOrder: orderType === CREATE_ORDER_TYPE,
                        isNewaddress: true,
                        pro: false,
                        saveAsDraftOrder: false,
                        sendInvoice: sendInvoiceFeature,
                        doNotShowCheckOutInfoPopUp: orderType === CREATE_CHECKOUT ? defaultPopupStateFromDb : false,
                        lineItemDiscountObject: discount_idObject,
                        discountApplyOnSubTotal: (discount_idObject === null || discount_idObject === void 0 ? void 0 : discount_idObject.discountOnSubTotal) ? Number(discount_idObject === null || discount_idObject === void 0 ? void 0 : discount_idObject.discountOnSubTotal) : 0,
                        discountType: selectedDiscountType,
                    });
                    setOrderPlacedMsg({ msg: loadingMessages[orderType], color: "blue" });
                    isLoading.next(true);
                    return [4 /*yield*/, createOrders(createOrderDataObject, isEditOrder)];
                case 1:
                    successDataPost = _4.sent();
                    if (typeof successDataPost === "string" && successDataPost !== "") {
                        handleSuccess(orderType, successDataPost);
                    }
                    else if (successDataPost && isEditOrder) {
                        // Handle success for isEditOrder type
                        handleSuccess(orderType);
                    }
                    else {
                        setOrderPlacedMsg({ msg: t("customerInvoice_ErrorMsgTryAgain"), color: "red" });
                        setAlertErrorMsg({ msg: t("customerInvoice_ErrorMsgTryAgain"), open: true, severity: "error" });
                        setOrderCreateBtn(false);
                        setTimeout(function () {
                            setOrderPlacedMsg({ msg: "", color: "" });
                        }, 2000);
                    }
                    setIsConfirmOpen(false);
                    isLoading.next(false);
                    _4.label = 2;
                case 2: return [3 /*break*/, 4];
                case 3:
                    error_1 = _4.sent();
                    setAlertErrorMsg({ msg: t("customerInvoice_ErrorMsgTryAgain"), open: true, severity: "error" });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleSuccess = function (orderType, successDataPost) {
        var _a;
        handleUpdateReduxState({}, SalesRepDataActionType.CREATE_ORDER_TAB);
        setOrderPlacedMsg({ msg: successMessages[orderType], color: "green" });
        setAlertErrorMsg({ msg: successMessages[orderType], open: true, severity: "success" });
        setOrderCreatedSuccessfully(true);
        setOrderCreateBtn(true);
        setTimeout(function () {
            setOrderPlacedMsg({ msg: "", color: "" });
        }, TOASTER_TIMEOUT);
        handleUpdateReduxState([], SalesRepDataActionType.DRAFT_ORDER_DATA);
        handleUpdateReduxState({}, SalesRepDataActionType.EDIT_DRAFT_ORDER);
        productAddOnCart({}, "clear.js"); // Clear Cart
        handleBackToShopBtn(); // Show all products
        setSearchProductArray(false);
        setSelectedOrderType("");
        setDiscount_idObject({});
        // Redirect to checkout
        if (orderType === CREATE_CHECKOUT) {
            setIsConfirmOpen(false);
            var invoiceRedirectUrl_1 = isEditOrder ? (_a = editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.draftOrderObj) === null || _a === void 0 ? void 0 : _a.invoice_url : successDataPost;
            setTimeout(function () {
                if (typeof invoiceRedirectUrl_1 === "string" && invoiceRedirectUrl_1) {
                    var appendSkipShopPay = shopName === SHOP_CHECKOUT_SKIP_SHOP_PAY_DOMAIN;
                    window.location.href = appendSkipShopPay
                        ? "".concat(invoiceRedirectUrl_1).concat(invoiceRedirectUrl_1.includes("?") ? "&" : "?", "skip_shop_pay=true")
                        : invoiceRedirectUrl_1;
                }
                else {
                    window.location.href = invoiceRedirectUrl_1;
                }
            }, 3000);
        }
        setEditOrderReduxData({});
        isEditOrder = false;
    };
    var checkUncheck = function (event, selectType, productObject, variantObject) {
        var _a, _b;
        var _c, _d, _e, _f, _g;
        if ((productSelectedArray === null || productSelectedArray === void 0 ? void 0 : productSelectedArray.length) === 0) {
            productAddOnCart({}, "clear.js"); //Clear Cart
        }
        if (productObject && ((_c = Object.keys(productObject)) === null || _c === void 0 ? void 0 : _c.length) !== 0 && ((_d = productObject.variants) === null || _d === void 0 ? void 0 : _d.length) > 0) {
            var checked = event.target.checked;
            var TempProduct_idObject = __assign({}, product_idObject);
            var TempVariant_idObject_1 = __assign({}, variant_idObject);
            var variantsAndQuantityArray_1 = [];
            var variantsAndQuantityObject_1 = {};
            var subtotalCount_1 = __assign({}, subtotal);
            var TempProductObject_1 = productObject ? JSON.parse(JSON.stringify(productObject)) : {};
            var TempVariantObject_1 = variantObject ? JSON.parse(JSON.stringify(variantObject)) : {};
            var errorVariantsId_1 = {};
            var DiscountIdObject_1 = __assign({}, discount_idObject);
            var isErrorObject_1 = __assign({}, isDiscountError);
            if (selectType === "isProduct") {
                if (checked) {
                    //check  isNotEmpty
                    if (isNotEmpty(product_idObject[productObject.productId])) {
                        //product id already there
                        productSelectedArray === null || productSelectedArray === void 0 ? void 0 : productSelectedArray.map(function (selectedArrayProduct) {
                            var _a;
                            if (selectedArrayProduct.productId === productObject.productId) {
                                selectedArrayProduct.variants = TempProductObject_1.variants;
                                setProductSelectedArray(__spreadArray([], productSelectedArray, true));
                                (_a = TempProductObject_1.variants) === null || _a === void 0 ? void 0 : _a.map(function (variant) {
                                    var _a;
                                    TempVariant_idObject_1[variant.variantId] = 1;
                                    subtotalCount_1[variant.variantId] = 1 * handlePrice(variant);
                                    setVariant_idObject(__assign({}, TempVariant_idObject_1));
                                    setSubtotal(__assign({}, subtotalCount_1));
                                    variantsAndQuantityArray_1.push({ id: variant.variantId, quantity: 1 });
                                    errorVariantsId_1 = __assign(__assign({}, errorVariantsId_1), (_a = {}, _a[variant.variantId] = false, _a));
                                });
                                productAddOnCart(variantsAndQuantityArray_1, "add.js"); //Product Adding on Cart Json
                            }
                        });
                        setIsError(__assign(__assign({}, isError), errorVariantsId_1));
                    }
                    else {
                        //new added
                        setProductSelectedArray(__spreadArray(__spreadArray([], productSelectedArray, true), [TempProductObject_1], false));
                        TempProduct_idObject[productObject.productId] = productObject.productId;
                        setProduct_idObject(__assign({}, TempProduct_idObject));
                        (_e = TempProductObject_1.variants) === null || _e === void 0 ? void 0 : _e.map(function (variant) {
                            var _a;
                            TempVariant_idObject_1[variant.variantId] = 1;
                            subtotalCount_1[variant.variantId] = 1 * handlePrice(variant);
                            setVariant_idObject(__assign({}, TempVariant_idObject_1));
                            setSubtotal(__assign({}, subtotalCount_1));
                            variantsAndQuantityArray_1.push({ id: variant.variantId, quantity: 1 });
                            errorVariantsId_1 = __assign(__assign({}, errorVariantsId_1), (_a = {}, _a[variant.variantId] = false, _a));
                        });
                        setIsError(__assign(__assign({}, isError), errorVariantsId_1));
                        setTimeout(function () {
                            productAddOnCart(variantsAndQuantityArray_1, "add.js"); //Product Adding on Cart Json
                        }, (productSelectedArray === null || productSelectedArray === void 0 ? void 0 : productSelectedArray.length) === 0 ? 500 : 10);
                    }
                }
                else {
                    //uncheck
                    var filteredArrayRemove = productSelectedArray === null || productSelectedArray === void 0 ? void 0 : productSelectedArray.filter(function (product) {
                        return product.productId !== productObject.productId;
                    });
                    setProductSelectedArray(__spreadArray([], filteredArrayRemove, true));
                    delete product_idObject[productObject.productId];
                    (_f = TempProductObject_1.variants) === null || _f === void 0 ? void 0 : _f.map(function (variant) {
                        var _a, _b;
                        var _c;
                        delete variant_idObject[variant.variantId];
                        delete subtotal[variant.variantId];
                        if (ShopApplyDiscount || isDiscoutAppliedInEditDraft) {
                            delete DiscountIdObject_1[variant.variantId];
                            delete isErrorObject_1[variant.variantId];
                            if (((_c = Object.values(subtotal)) === null || _c === void 0 ? void 0 : _c.length) <= 0) {
                                if (DiscountIdObject_1["discountOnSubTotal"]) {
                                    delete DiscountIdObject_1["discountOnSubTotal"];
                                }
                                setDiscount_ApplyOnSubTotal("0");
                                isErrorObject_1["discountOnSubTotal"] = false;
                            }
                        }
                        setSubtotal(__assign({}, subtotal));
                        variantsAndQuantityObject_1 = __assign(__assign({}, variantsAndQuantityObject_1), (_a = {}, _a[variant === null || variant === void 0 ? void 0 : variant.variantId] = 0, _a));
                        errorVariantsId_1 = __assign(__assign({}, errorVariantsId_1), (_b = {}, _b[variant === null || variant === void 0 ? void 0 : variant.variantId] = false, _b));
                    });
                    if (ShopApplyDiscount || isDiscoutAppliedInEditDraft) {
                        setIsDiscountError(__assign({}, isErrorObject_1));
                        setDiscount_idObject(__assign({}, DiscountIdObject_1));
                    }
                    productAddOnCart(variantsAndQuantityObject_1, "update.js"); //Product Remove on Cart Json
                    setIsError(__assign(__assign({}, isError), errorVariantsId_1));
                }
            }
            else {
                //isvariant
                if (checked) {
                    if (isNotEmpty(product_idObject[productObject.productId])) {
                        //product id already there
                        productSelectedArray === null || productSelectedArray === void 0 ? void 0 : productSelectedArray.map(function (selectedArrayProduct) {
                            if (selectedArrayProduct.productId === productObject.productId) {
                                selectedArrayProduct.variants = __spreadArray(__spreadArray([], selectedArrayProduct.variants, true), [__assign(__assign({}, TempVariantObject_1), { quantity: 1 })], false);
                                setProductSelectedArray(__spreadArray([], productSelectedArray, true));
                                TempVariant_idObject_1[variantObject.variantId] = 1;
                                subtotalCount_1[variantObject.variantId] = 1 * handlePrice(variantObject);
                                setVariant_idObject(__assign({}, TempVariant_idObject_1));
                                setSubtotal(__assign({}, subtotalCount_1));
                                variantsAndQuantityArray_1.push({ id: variantObject.variantId, quantity: 1 });
                                productAddOnCart(variantsAndQuantityArray_1, "add.js"); //Product Adding on Cart Json
                                return selectedArrayProduct;
                            }
                        });
                    }
                    else {
                        // newly added variant
                        var newObject = __assign(__assign({}, TempProductObject_1), { variants: [TempVariantObject_1] });
                        setProductSelectedArray(__spreadArray(__spreadArray([], productSelectedArray, true), [newObject], false));
                        TempProduct_idObject[productObject.productId] = productObject.productId;
                        setProduct_idObject(__assign({}, TempProduct_idObject));
                        TempVariant_idObject_1[variantObject.variantId] = 1;
                        subtotalCount_1[variantObject.variantId] = 1 * handlePrice(variantObject);
                        setVariant_idObject(__assign({}, TempVariant_idObject_1));
                        setSubtotal(__assign({}, subtotalCount_1));
                        variantsAndQuantityArray_1.push({ id: variantObject.variantId, quantity: 1 });
                        setTimeout(function () {
                            productAddOnCart(variantsAndQuantityArray_1, "add.js"); //Product Adding on Cart Json
                        }, (productSelectedArray === null || productSelectedArray === void 0 ? void 0 : productSelectedArray.length) === 0 ? 500 : 10);
                    }
                }
                else {
                    //variant uncheck
                    var filteredArrayRemove1 = [];
                    productSelectedArray === null || productSelectedArray === void 0 ? void 0 : productSelectedArray.forEach(function (productFiltered) {
                        var _a;
                        return (_a = productFiltered.variants) === null || _a === void 0 ? void 0 : _a.forEach(function (variant, index) {
                            if (variant.variantId === variantObject.variantId) {
                                return productFiltered.variants.splice(index, 1);
                            }
                        });
                    });
                    filteredArrayRemove1 = productSelectedArray === null || productSelectedArray === void 0 ? void 0 : productSelectedArray.filter(function (Product) {
                        var _a, _b, _c;
                        if (((_a = Product === null || Product === void 0 ? void 0 : Product.variants) === null || _a === void 0 ? void 0 : _a.length) >= 1) {
                            return ((_b = Product === null || Product === void 0 ? void 0 : Product.variants) === null || _b === void 0 ? void 0 : _b.length) >= 1;
                        }
                        if (((_c = Product === null || Product === void 0 ? void 0 : Product.variants) === null || _c === void 0 ? void 0 : _c.length) === 0) {
                            delete product_idObject[Product.productId];
                        }
                    });
                    setProductSelectedArray(__spreadArray([], filteredArrayRemove1, true));
                    delete variant_idObject[variantObject.variantId];
                    delete subtotal[variantObject.variantId];
                    if (ShopApplyDiscount || isDiscoutAppliedInEditDraft) {
                        delete DiscountIdObject_1[variantObject.variantId];
                        delete isErrorObject_1[variantObject.variantId];
                        if (((_g = Object.values(subtotal)) === null || _g === void 0 ? void 0 : _g.length) <= 0) {
                            if (DiscountIdObject_1["discountOnSubTotal"]) {
                                delete DiscountIdObject_1["discountOnSubTotal"];
                            }
                            setDiscount_ApplyOnSubTotal("0");
                            isErrorObject_1["discountOnSubTotal"] = false;
                        }
                        setDiscount_idObject(__assign({}, DiscountIdObject_1));
                        setIsDiscountError(__assign({}, isErrorObject_1));
                    }
                    setSubtotal(__assign({}, subtotal));
                    variantsAndQuantityObject_1 = (_a = {},
                        _a[variantObject.variantId] = 0,
                        _a);
                    productAddOnCart(variantsAndQuantityObject_1, "update.js"); //Product Removing on Cart Json
                }
                setIsError(__assign(__assign({}, isError), (_b = {}, _b[TempVariantObject_1 === null || TempVariantObject_1 === void 0 ? void 0 : TempVariantObject_1.variantId] = false, _b)));
            }
        }
        else {
            setAlertErrorMsg({ msg: t("customerInvoice_AlertErrorMsg"), open: true });
        }
    };
    var handleAlertMsgClose = function (event, reason) {
        if (reason === "clickaway") {
            return;
        }
        setAlertErrorMsg({ msg: "", open: false });
    };
    var isNotEmpty = function (params) {
        if (params !== null && params !== undefined) {
            return true;
        }
        else {
            return false;
        }
    };
    //Update Cart or Cart.json
    var productAddOnCart = function (Parameter, Type) { return __awaiter(_this, void 0, void 0, function () {
        var isCartDataUpdated;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setCartUpdatedSuccessFully(false);
                    return [4 /*yield*/, dispatch(dataAddingOnCart(Parameter, Type))];
                case 1:
                    isCartDataUpdated = _a.sent();
                    if (typeof isCartDataUpdated === "boolean" && isCartDataUpdated === true) {
                        setShippingCost(""); //Empty selected "shipping Cost"
                        setShippingCostData([]); //Empty shipping Cost "Options"
                        setApplyShippingCost(""); //There is no Select(apply cost..Yes or No)
                        setIsDisabledShippingCostRadioBtn_YesNo(false);
                        setCartUpdatedSuccessFully(true);
                    }
                    else {
                        if (isCartDataUpdated === "Request failed with status code 404") {
                            setAlertErrorMsg({ msg: t("customerInvoice_EditOrder_ErrorMsgForCartUpdate"), open: true });
                        }
                        else {
                            setAlertErrorMsg({ msg: isCartDataUpdated, open: true });
                        }
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    //checkConditions... for Shipping Address
    var checkConditions = function (uses, event) {
        var _a, _b, _c, _d, _e, _f, _g;
        var shippingaddressID = ((_a = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _a === void 0 ? void 0 : _a.shippingAddress)
            ? (_b = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _b === void 0 ? void 0 : _b.shippingAddress.toString()
            : (_e = (_d = (_c = store.getState().salesRepData) === null || _c === void 0 ? void 0 : _c.createOrderTab) === null || _d === void 0 ? void 0 : _d.customer_shippingaddressID) !== null && _e !== void 0 ? _e : "";
        if (shippingaddressID !== "") {
            if (((_f = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _f === void 0 ? void 0 : _f.zipNumber) !== "" && shippingAddresSet === "") {
                if (uses === CREATE_ORDER_TYPE && event !== DRAFT_ORDER) {
                    setAlertErrorMsg({ msg: t("customerInvoice_PleaseSetAnyShippingAddressMsg"), open: true });
                    return;
                }
            }
            else if (((_g = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _g === void 0 ? void 0 : _g.zipNumber) === "") {
                shippingAddressFlag = true;
                setShippingAddressSet("customerAddress");
                shippingAddresSetVariable = "customerAddress";
            }
            else if (shippingAddresSet !== "") {
                shippingAddressFlag = true;
            }
            else {
                setShippingAddressSet("customerAddress");
                shippingAddresSetVariable = "customerAddress";
                shippingAddressFlag = true;
            }
        }
        else {
            if (inputFieldsData === null || inputFieldsData === void 0 ? void 0 : inputFieldsData.newAddress.every(function (fieldObject, index) { return fieldObject[index] === ""; })) {
                shippingAddressFlag = false;
                setShippingAddressSet("");
                shippingAddresSetVariable = "";
                if (uses === CREATE_ORDER_TYPE && event !== DRAFT_ORDER) {
                    setAlertErrorMsg({ msg: t("customerInvoice_AddShippingAddress_Msg"), open: true });
                    return;
                }
            }
            else {
                if (inputFieldsData === null || inputFieldsData === void 0 ? void 0 : inputFieldsData.newAddress.every(function (fieldObject, index) { return fieldObject[index] !== ""; })) {
                    shippingAddressFlag = true;
                    setShippingAddressSet("formAddress");
                    shippingAddresSetVariable = "formAddress";
                }
                else {
                    checkAddressInputField();
                }
            }
        }
    };
    //get Shipping Cost using Api Call
    var GetShippingRatesOnSelectedAddress = function () { return __awaiter(_this, void 0, void 0, function () {
        var customerAddressesListArray, shippingaddressID, CustomerAddressData_1, responseShippingRates;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        return __generator(this, function (_o) {
            switch (_o.label) {
                case 0:
                    setShippingCost("");
                    setShippingCostData([]);
                    setApplyShippingCost("");
                    setIsDisabledShippingCostRadioBtn_YesNo(false);
                    customerAddressesListArray = [];
                    if ((props === null || props === void 0 ? void 0 : props.customerAddressesList) && ((_a = props === null || props === void 0 ? void 0 : props.customerAddressesList) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                        customerAddressesListArray = props === null || props === void 0 ? void 0 : props.customerAddressesList;
                    }
                    else {
                        customerAddressesListArray = (_c = (_b = store.getState().salesRepData) === null || _b === void 0 ? void 0 : _b.customerNewUpdatedData) === null || _c === void 0 ? void 0 : _c.customerAddressesList;
                    }
                    shippingaddressID = (props === null || props === void 0 ? void 0 : props.customerInfo.shippingAddress)
                        ? props === null || props === void 0 ? void 0 : props.customerInfo.shippingAddress.toString()
                        : (_f = (_e = (_d = store.getState().salesRepData) === null || _d === void 0 ? void 0 : _d.createOrderTab) === null || _e === void 0 ? void 0 : _e.customer_shippingaddressID) !== null && _f !== void 0 ? _f : "";
                    checkConditions("GetShippingRates", ""); //checking shipping address
                    if (!(shippingAddressFlag && shippingAddresSetVariable !== "")) return [3 /*break*/, 2];
                    CustomerAddressData_1 = {
                        customerCountry: "",
                        customerProvince: "",
                        customerZip: "",
                    };
                    if (shippingAddresSetVariable === "formAddress") {
                        CustomerAddressData_1.customerCountry = (_g = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _g === void 0 ? void 0 : _g.selectCountry;
                        CustomerAddressData_1.customerProvince = ((_h = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _h === void 0 ? void 0 : _h.selectCountryState) ? (_j = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _j === void 0 ? void 0 : _j.selectCountryState : (_k = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _k === void 0 ? void 0 : _k.city;
                        CustomerAddressData_1.customerZip = (_l = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _l === void 0 ? void 0 : _l.zipNumber;
                    }
                    else if (shippingAddresSetVariable === "customerAddress") {
                        customerAddressesListArray === null || customerAddressesListArray === void 0 ? void 0 : customerAddressesListArray.map(function (option) {
                            var _a;
                            if (((_a = option === null || option === void 0 ? void 0 : option.id) === null || _a === void 0 ? void 0 : _a.toString()) === shippingaddressID) {
                                CustomerAddressData_1.customerCountry = (option === null || option === void 0 ? void 0 : option.country) || "";
                                CustomerAddressData_1.customerProvince = (option === null || option === void 0 ? void 0 : option.province) ? option === null || option === void 0 ? void 0 : option.province : option === null || option === void 0 ? void 0 : option.city;
                                CustomerAddressData_1.customerZip = (option === null || option === void 0 ? void 0 : option.zip) || "";
                            }
                        });
                    }
                    if (CustomerAddressData_1.customerCountry === "Great Britain (UK)") {
                        CustomerAddressData_1.customerCountry = "United Kingdom";
                    }
                    else if (CustomerAddressData_1.customerCountry === "United States of America") {
                        CustomerAddressData_1.customerCountry = "United States";
                    }
                    setShippingCost(t("customerInvoice_CalculatingShippingRates_Msg"));
                    return [4 /*yield*/, getShippingRatesService(CustomerAddressData_1)];
                case 1:
                    responseShippingRates = _o.sent();
                    setShippingCost("");
                    if (responseShippingRates != null &&
                        responseShippingRates != undefined &&
                        responseShippingRates.hasOwnProperty("shipping_rates") &&
                        (responseShippingRates === null || responseShippingRates === void 0 ? void 0 : responseShippingRates.message) === "Success") {
                        setShippingCostData(responseShippingRates === null || responseShippingRates === void 0 ? void 0 : responseShippingRates.shipping_rates);
                        if (((_m = responseShippingRates === null || responseShippingRates === void 0 ? void 0 : responseShippingRates.shipping_rates) === null || _m === void 0 ? void 0 : _m.length) === 0) {
                            setAlertErrorMsg({ msg: t("ShippingCost_AddressError"), open: true, severity: "warning" });
                            setApplyShippingCost("No");
                            setIsDisabledShippingCostRadioBtn_YesNo(true);
                        }
                        //ShopWiseCustomization(shopName, "GeneratesShippingRates", { setAlertErrorMsg, shippingRatesArray: responseShippingRates?.shipping_rates }); //Customization
                        return [2 /*return*/, true];
                    }
                    else {
                        if ((responseShippingRates === null || responseShippingRates === void 0 ? void 0 : responseShippingRates.message) === "Success") {
                            setAlertErrorMsg({ msg: t("customerInvoice_ShippingCostErrorMsg_TryAgain"), open: true });
                        }
                        else {
                            setAlertErrorMsg({ msg: responseShippingRates === null || responseShippingRates === void 0 ? void 0 : responseShippingRates.message, open: true });
                        }
                        return [2 /*return*/, false];
                    }
                    _o.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleSelectShippingAddress = function (set) {
        setShippingAddressSet(set);
        setShippingCost("");
        setShippingCostData([]);
        setApplyShippingCost("");
        setIsDisabledShippingCostRadioBtn_YesNo(false);
    };
    var handleShippingCostApply = function (param) {
        setApplyShippingCost(param);
    };
    var checkAddressInputField = function () {
        var _a;
        for (var index = 0; index < ((_a = inputFieldsData === null || inputFieldsData === void 0 ? void 0 : inputFieldsData.newAddress) === null || _a === void 0 ? void 0 : _a.length); index++) {
            if ((inputFieldsData === null || inputFieldsData === void 0 ? void 0 : inputFieldsData.newAddress[index][index]) === "") {
                setAlertErrorMsg({ msg: inputFieldsData === null || inputFieldsData === void 0 ? void 0 : inputFieldsData.newAddress[index].errorMsg, open: true });
                break;
            }
        }
    };
    var handleProductQuantity = function (e, variantId, price) {
        var _a, _b;
        if (!variantId) {
            setAlertErrorMsg({ msg: t("customerInvoice_AlertErrorMsg"), open: true });
            return;
        }
        var _c = e.target, name = _c.name, value = _c.value;
        if (!checkQuantityValidation(value, variantId)) {
            var quantity = parseInt(value);
            var subtotalCount = __assign({}, subtotal);
            var DiscountIdObject = __assign({}, discount_idObject);
            var VariantIdObject = __assign({}, variant_idObject);
            var isErrorObject = __assign({}, isDiscountError);
            var isDicountOnvariantId = DiscountIdObject.hasOwnProperty(variantId);
            subtotalCount[variantId] = quantity * price;
            if ((ShopApplyDiscount || isDiscoutAppliedInEditDraft) && isDicountOnvariantId) {
                var discountValue = parseFloat(DiscountIdObject[variantId].toString());
                var discountType = selectedDiscountType;
                var discountApplied = 0.0;
                if (discountType === "percentage") {
                    discountApplied = subtotalCount[variantId] * (1 - discountValue / 100);
                }
                else {
                    var discountedAmountOfSingleProduct = price - discountValue;
                    discountApplied = quantity * discountedAmountOfSingleProduct;
                }
                subtotalCount[variantId] = discountApplied;
            }
            productAddOnCart((_a = {}, _a[variantId] = value, _a), "update.js");
            setVariant_idObject(__assign(__assign({}, VariantIdObject), (_b = {}, _b[variantId] = value, _b)));
            setSubtotal(__assign({}, subtotalCount));
            setDiscount_idObject(__assign({}, DiscountIdObject));
            setIsDiscountError(isErrorObject);
        }
    };
    var checkQuantityValidation = function (value, variantId) {
        var quantity = parseInt(value);
        var isValid = quantity > 0;
        setIsError(function (prevErrors) {
            var _a;
            return (__assign(__assign({}, prevErrors), (_a = {}, _a[variantId] = !isValid, _a)));
        });
        if (!isValid) {
            setVariant_idObject(function (prevVariantIds) {
                var _a;
                return (__assign(__assign({}, prevVariantIds), (_a = {}, _a[variantId] = "", _a)));
            });
            setSubtotal(function (prevSubtotals) {
                var _a;
                return (__assign(__assign({}, prevSubtotals), (_a = {}, _a[variantId] = 0, _a)));
            });
            setAlertErrorMsg({ msg: t("productTable_error_AlertMsg"), open: true });
        }
        return !isValid;
    };
    var handleUpdateReduxState = function (payloadData, actionType) {
        var updateReduxState = {
            payload: payloadData,
            type: actionType,
        };
        dispatch(updateReduxState);
    };
    var checkIsPlacingMessage = function () {
        var isPlacingOrder = orderPlacedMsg.msg === t("customerInvoice_Sending_Msg") ||
            orderPlacedMsg.msg === t("customerInvoice_Creating_Msg") ||
            orderPlacedMsg.msg === t("customerInvoice_CreatingDraft_Msg") ||
            orderPlacedMsg.msg === t("customerInvoice_CreatingDraftCheckout");
        return isPlacingOrder;
    };
    var handleOpenConfirm = function () {
        setIsConfirmOpen(!isConfirmOpen);
    };
    var handlePrice = function (variantObj) {
        var _a, _b, _c, _d;
        var customerTagWisePricesObj = (_c = (_b = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.createOrderTab) === null || _b === void 0 ? void 0 : _b.wholePriceObj) !== null && _c !== void 0 ? _c : {};
        if ((selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.PriceList) && ((_d = Object.keys(customerTagWisePricesObj)) === null || _d === void 0 ? void 0 : _d.length) > 0 && customerTagWisePricesObj[variantObj === null || variantObj === void 0 ? void 0 : variantObj.variantId]) {
            return customerTagWisePricesObj[variantObj === null || variantObj === void 0 ? void 0 : variantObj.variantId]; //wholesale price
        }
        else {
            return variantObj === null || variantObj === void 0 ? void 0 : variantObj.variantPrice; //retail price
        }
    };
    var appliedDiscount = function (e, variantId, price) {
        var _a = e.target, name = _a.name, value = _a.value;
        var DiscountIdObject = __assign({}, discount_idObject);
        var subtotalCount = __assign({}, subtotal);
        var VariantIdObject = __assign({}, variant_idObject);
        var isErrorObject = {};
        if (variantId) {
            if (value !== "") {
                DiscountIdObject[variantId] = value;
                if (selectedDiscountType === "percentage") {
                    if (parseFloat(value) > 0 && parseFloat(value) <= 100) {
                        var subtotal_1 = VariantIdObject[variantId] * price;
                        var discountedAmount = parseFloat(((parseFloat(value) * subtotal_1) / 100).toFixed(2));
                        var discountApplied = subtotal_1 - discountedAmount;
                        subtotalCount[variantId] = discountApplied;
                        isErrorObject[variantId] = false;
                    }
                    else {
                        isErrorObject[variantId] = true;
                    }
                }
                else {
                    if (parseFloat(value) >= 0 && parseFloat(value) <= price) {
                        var discountefSingleProductAmount = price - parseFloat(value);
                        var discountApplied = VariantIdObject[variantId] * discountefSingleProductAmount;
                        subtotalCount[variantId] = discountApplied;
                        isErrorObject[variantId] = false;
                    }
                    else {
                        isErrorObject[variantId] = true;
                    }
                }
            }
            else {
                subtotalCount[variantId] = VariantIdObject[variantId] * price;
                delete DiscountIdObject[variantId];
                isErrorObject[variantId] = false;
            }
            setSubtotal(__assign({}, subtotalCount));
            setDiscount_idObject(__assign({}, DiscountIdObject));
            setIsDiscountError(__assign(__assign({}, isDiscountError), isErrorObject));
        }
        else {
            setAlertErrorMsg({ msg: t("customerInvoice_AlertErrorMsg"), open: true });
        }
    };
    var appliedDiscountOnSubtotal = function (e, discountOnSubTotal, price) {
        var _a, _b;
        var _c = e.target, name = _c.name, value = _c.value;
        var DiscountIdObject = __assign({}, discount_idObject);
        var isErrorObject = {};
        if (discountOnSubTotal) {
            if (value !== "") {
                DiscountIdObject[discountOnSubTotal] = value;
                if (selectedDiscountType === "percentage") {
                    if (parseInt(value) >= 0 && parseInt(value) <= 100) {
                        var subtotal_2 = price;
                        var discountApplyed = subtotal_2 - (parseFloat(value) * subtotal_2) / 100;
                        setDiscount_ApplyOnSubTotal((_a = discountApplyed.toString()) !== null && _a !== void 0 ? _a : 0);
                        isErrorObject[discountOnSubTotal] = false;
                    }
                    else {
                        isErrorObject[discountOnSubTotal] = true;
                    }
                }
                else {
                    if (parseFloat(value) >= 0 && parseFloat(value) <= price) {
                        var subtotal_3 = price;
                        var discountApplyed = subtotal_3 - parseFloat(value);
                        setDiscount_ApplyOnSubTotal((_b = discountApplyed.toString()) !== null && _b !== void 0 ? _b : 0);
                        isErrorObject[discountOnSubTotal] = false;
                    }
                    else {
                        isErrorObject[discountOnSubTotal] = true;
                    }
                }
            }
            else {
                setDiscount_ApplyOnSubTotal(price.toString());
                delete DiscountIdObject[discountOnSubTotal];
                isErrorObject[discountOnSubTotal] = false;
            }
            setDiscount_idObject(__assign({}, DiscountIdObject));
            setIsDiscountError(__assign(__assign({}, isDiscountError), isErrorObject));
        }
        else {
            setAlertErrorMsg({ msg: t("customerInvoice_AlertErrorMsg"), open: true });
        }
    };
    var handleSelectChangeForDiscountType = function (event) {
        setPendingDiscountType(event.target.value);
        setDiscountAlertBox(true);
    };
    var handleConfirmChangeDiscountType = function () {
        setDiscountAlertBox(false);
        setSelectedDiscountType(pendingDiscountType);
        var VariantIdObject = __assign({}, variant_idObject);
        var subtotalCount = __assign({}, subtotal);
        productSelectedArray === null || productSelectedArray === void 0 ? void 0 : productSelectedArray.forEach(function (product) {
            var _a;
            (_a = product === null || product === void 0 ? void 0 : product.variants) === null || _a === void 0 ? void 0 : _a.forEach(function (variant) {
                subtotalCount[variant === null || variant === void 0 ? void 0 : variant.variantId] = VariantIdObject[variant === null || variant === void 0 ? void 0 : variant.variantId] * handlePrice(variant);
            });
        });
        setSubtotal(__assign({}, subtotalCount));
        setDiscount_idObject({});
    };
    var handleCancelChangeDiscountType = function () {
        setDiscountAlertBox(false);
    };
    return {
        defaultPopupStateFromDb: defaultPopupStateFromDb,
        selectedOrderType: selectedOrderType,
        setSelectedOrderType: setSelectedOrderType,
        t: t,
        salesRepData: salesRepData,
        shopCurrency: shopCurrency,
        Products: Products,
        setProduct: setProduct,
        search_By_productInfo: search_By_productInfo,
        setSearch_By_productInfo: setSearch_By_productInfo,
        orderNotes: orderNotes,
        setOrderNotes: setOrderNotes,
        orderPlacedMsg: orderPlacedMsg,
        setOrderPlacedMsg: setOrderPlacedMsg,
        subtotal: subtotal,
        setSubtotal: setSubtotal,
        totalPrice: totalPrice,
        setTotalPrice: setTotalPrice,
        backToShopBtn: backToShopBtn,
        setBackToShopBtn: setBackToShopBtn,
        SearchProduct: SearchProduct,
        handleQuantityIncrementDecrement: handleQuantityIncrementDecrement,
        handleSelectedBtn: handleSelectedBtn,
        handleBackToShopBtn: handleBackToShopBtn,
        CreateOrder: CreateOrder,
        renderImageSrc: renderImageSrc,
        checkUncheck: checkUncheck,
        product_idObject: product_idObject,
        variant_idObject: variant_idObject,
        productSelectedArray: productSelectedArray,
        setProductSelectedArray: setProductSelectedArray,
        setVariant_idObject: setVariant_idObject,
        setProduct_idObject: setProduct_idObject,
        handleAlertMsgClose: handleAlertMsgClose,
        isNotEmpty: isNotEmpty,
        scrollParentRef: scrollParentRef,
        setScrollParentRef: setScrollParentRef,
        customizedTextStrings: customizedTextStrings,
        hideRetailPriceColumn: hideRetailPriceColumn,
        GetShippingRatesOnSelectedAddress: GetShippingRatesOnSelectedAddress,
        shippingCost: shippingCost,
        setShippingCost: setShippingCost,
        alertErrorMsg: alertErrorMsg,
        handleSelectShippingAddress: handleSelectShippingAddress,
        shippingAddresSet: shippingAddresSet,
        setShippingAddressSet: setShippingAddressSet,
        shippingCostData: shippingCostData,
        setShippingCostData: setShippingCostData,
        handleShippingCostApply: handleShippingCostApply,
        applyShippingCost: applyShippingCost,
        setApplyShippingCost: setApplyShippingCost,
        shopName: shopName,
        //ShopWiseCustomization,
        isDisabledShippingCostRadioBtn_No: isDisabledShippingCostRadioBtn_No,
        setIsDisabledShippingCostRadioBtn_No: setIsDisabledShippingCostRadioBtn_No,
        isDisabledShippingCostRadioBtn_YesNo: isDisabledShippingCostRadioBtn_YesNo,
        selectFeatures: selectFeatures,
        handleProductQuantity: handleProductQuantity,
        isError: isError,
        isMobile: isMobile,
        checkIsPlacingMessage: checkIsPlacingMessage,
        orderCreatedSuccessfully: orderCreatedSuccessfully,
        setOrderCreatedSuccessfully: setOrderCreatedSuccessfully,
        productsLoading: productsLoading,
        handleUpdateReduxState: handleUpdateReduxState,
        sendInvoiceFeature: sendInvoiceFeature,
        setSendInvoiceFeature: setSendInvoiceFeature,
        handleOrderTypeChange: handleOrderTypeChange,
        cartUpdatedSuccessFully: cartUpdatedSuccessFully,
        isConfirmOpen: isConfirmOpen,
        handleOpenConfirm: handleOpenConfirm,
        setCartUpdatedSuccessFully: setCartUpdatedSuccessFully,
        isEditOrder: isEditOrder,
        setIsError: setIsError,
        handlePrice: handlePrice,
        productTableRowsPerPage: productTableRowsPerPage,
        createOrderInnerScroll: createOrderInnerScroll,
        appliedDiscount: appliedDiscount,
        isDiscountError: isDiscountError,
        discount_idObject: discount_idObject,
        setDiscount_idObject: setDiscount_idObject,
        selectedDiscountType: selectedDiscountType,
        handleSelectChangeForDiscountType: handleSelectChangeForDiscountType,
        discount_ApplyOnSubTotal: discount_ApplyOnSubTotal,
        setDiscount_ApplyOnSubTotal: setDiscount_ApplyOnSubTotal,
        appliedDiscountOnSubtotal: appliedDiscountOnSubtotal,
        ShopApplyDiscount: ShopApplyDiscount,
        discountAlertBox: discountAlertBox,
        handleConfirmChangeDiscountType: handleConfirmChangeDiscountType,
        handleCancelChangeDiscountType: handleCancelChangeDiscountType,
        isDiscoutAppliedInEditDraft: isDiscoutAppliedInEditDraft,
        setAlertErrorMsg: setAlertErrorMsg,
        currency: currency,
    };
}
export function CssConstantObjects() {
    var isMobile = useDeviceQueries();
    var ST_CI_table = {
        minWidth: 650,
    };
    var ST_CI_tableDataCell = {
        pt: 0.5,
        pb: 0.5,
    };
    var ST_CI_renderPriceArea = {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        mt: 2,
    };
    var ST_CI_MinWidth = {
        minWidth: 228,
        mt: 1,
    };
    var ST_CI_TotalPriceRenderBox = {
        display: "flex",
        alignItems: "center",
        border: 1,
        borderRadius: 1,
        borderColor: "#d4d4d4",
        backgroundColor: "white",
        mt: 1,
        color: "black",
        "& svg": { m: 1.5 },
        "& hr": { borderColor: "black", borderWidth: 1, background: "black" },
        width: isMobile ? 400 : 280,
        height: isMobile ? 50 : 40,
    };
    var ST_CI_TotalPriceText = {
        fontWeight: 600,
        ml: 2,
        mr: 2,
    };
    var ST_CI_BtnArea = {
        display: "flex",
        justifyContent: isMobile ? "start" : "flex-end",
        // mt: 3,
        mb: 2,
    };
    var ST_CI_DisplayFlex = {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        mb: 3,
        mt: 3,
    };
    var ST_CI_AddMoreProducts_Btn = {
        mt: 2,
        mr: 1,
        whiteSpace: "nowrap",
    };
    var ST_CI_SearchProductGrid = {
        minWidth: isMobile ? 0 : 232,
        mt: 2,
        backgroundColor: "white",
        width: isMobile ? 400 : 0,
    };
    var ST_CI_ShippingCost = {
        display: "flex",
        flexWrap: "wrap",
    };
    var ST_CI_SippingCostBtn = {
        mt: 1,
        backgroundColor: "white",
        width: isMobile ? "100%" : 190,
        height: 36,
        fontSize: isMobile ? 14 : 11,
    };
    var ST_CI_SippingCost_TextField = {
        width: isMobile ? "100%" : 180,
        backgroundColor: "white",
        mt: 1,
        ml: isMobile ? 0 : 1,
    };
    var ST_CI_ApplyShippingCostRadio_Btn = {
        pl: "0.1rem",
        pt: "0rem",
        pb: "0rem",
        pr: "0rem",
    };
    var ST_CI_DisplayFlexEnd = {
        display: "flex",
        justifyContent: isMobile ? "start" : "flex-end",
        marginTop: isMobile ? 2 : 0,
    };
    var ST_CI_SendInvoice_CreateOrder_Btn = {
        width: isMobile ? "100%" : 100,
        height: isMobile ? 45 : 38,
        fontSize: isMobile ? 14 : 12,
        backgroundColor: "#1f76ce",
        boxShadow: "none !important",
    };
    return {
        ST_CI_table: ST_CI_table,
        ST_CI_tableDataCell: ST_CI_tableDataCell,
        ST_CI_renderPriceArea: ST_CI_renderPriceArea,
        ST_CI_MinWidth: ST_CI_MinWidth,
        ST_CI_TotalPriceRenderBox: ST_CI_TotalPriceRenderBox,
        ST_CI_TotalPriceText: ST_CI_TotalPriceText,
        ST_CI_BtnArea: ST_CI_BtnArea,
        ST_CI_DisplayFlex: ST_CI_DisplayFlex,
        ST_CI_AddMoreProducts_Btn: ST_CI_AddMoreProducts_Btn,
        ST_CI_SearchProductGrid: ST_CI_SearchProductGrid,
        ST_CI_ShippingCost: ST_CI_ShippingCost,
        ST_CI_DisplayFlexEnd: ST_CI_DisplayFlexEnd,
        ST_CI_ApplyShippingCostRadio_Btn: ST_CI_ApplyShippingCostRadio_Btn,
        ST_CI_SippingCostBtn: ST_CI_SippingCostBtn,
        ST_CI_SippingCost_TextField: ST_CI_SippingCost_TextField,
        ST_CI_SendInvoice_CreateOrder_Btn: ST_CI_SendInvoice_CreateOrder_Btn,
    };
}
